export default __webpack_public_path__ + "static/media/W_Warima.eb462e28.mp3";